<template>
  <div>
    <div class="specialClass">
      <full-floor
        title="初中精品班"
        adCode="872"
        :itemsList="floorJunior"
        :typeId="juniorTypeid"
        newsTitle="中考最新资讯"
      ></full-floor>
      <full-floor
        title="高中精品班"
        adCode="873"
        :itemsList="floorSenior"
        :typeId="seniorTypeid"
        newsTitle="高考最新资讯"
      ></full-floor>
    </div>
    <div class="abroad" v-show="abroadData.length && applyData.length">
      <div class="content">
        <small-floor
          title="去国外读大学"
          itemsList=""
          :data="abroadData"
        ></small-floor>
        <small-floor
          title="出国必考"
          :data="applyData"
        ></small-floor>
      </div>
      <introduce></introduce>
    </div>
    <international-study title="体验异国课堂"></international-study>
    <living title="中学直播精品班"></living>
    <teacher></teacher>
    <raiders></raiders>
    <keep-alive>
      <cart ></cart>
    </keep-alive>
  </div>
</template>

<script>
import { middleMainNav } from 'js/middleschool/mainnav.js'
import { middleFriendLinks } from 'js/middleschool/friendlinks.js'
import { cityFormInfo } from 'js/staticData.js'
import { getArticle } from 'js/getArticle.js'
import jsonp from 'js/jsonp.js'
import AdModel from '@/common-components/AdModel'
import InternationalStudy from './components/Internationalstudy'
import Introduce from './components/Introduce'
import Living from './components/Living'
import Raiders from './components/Raiders'
import FullFloor from './components/Floorfull'
import SmallFloor from './components/Floorsmall'
import Teacher from './components/Teacher'
import Cart from '@/common-components/Cart'
export default {
  name: 'Middlecourse',
  components: {
    Cart,
    AdModel,
    Introduce,
    InternationalStudy,
    Raiders,
    FullFloor,
    SmallFloor,
    Living,
    Teacher
  },
  data () {
    return {
      middleMainNav,
      middleFriendLinks,
      floorJunior: [],
      floorSenior: [],
      cityFormInfo,
      juniorTypeid: Number,
      seniorTypeid: Number,
      abroadData: [],
      applyData: []
    }
  },
  computed: {
    cityId () {
      return this.$store.state.soukecityId
    }
  },
  created () {
    if (this.cityId !== null) {
      this.juniorTypeid = cityFormInfo[this.cityId].juniorTypeid
      this.seniorTypeid = cityFormInfo[this.cityId].highTypeid
      setTimeout(() => {
        this.getAbroadData(this.cityId)
        this.getApplyData(this.cityId)
        this.getBoutiqueClassData(this.cityId)
      }, 20)
    }
  },
  watch: {
    cityId (newVal, oldVal) {
      this.juniorTypeid = cityFormInfo[newVal].juniorTypeid
      this.seniorTypeid = cityFormInfo[newVal].highTypeid
      this.getAbroadData(newVal)
      this.getApplyData(newVal)
      this.getBoutiqueClassData(newVal)
      return newVal
    }
  },
  methods: {
    getHotArticle () {
      getArticle('1161,1162,1163', 1, '_WWW').then(response => {
        this.hotArticleLeft = response[0]
      })
      getArticle('1440,4910,5181,1507,1509,1510', 4, '_WWW').then(response => {
        this.hotArticleLeftList = response
      })
      getArticle('1177,1178,1179', 1, '_WWW').then(response => {
        this.hotArticleRight = response[0]
      })
      getArticle('1533,8698,1172,1538,1539,1540', 4, '_WWW').then(response => {
        this.hotArticleRightList = response
      })
    },
    getAbroadData (cityId) {
      jsonp('http://cmsdt.xdf.cn/xdf_app/index.php', {
        method: 'Course.GetCourseByCategory',
        c: 'soukeapi',
        param: JSON.stringify({
          cityId,
          categoryCode: 7,
          attr: 1031,
          pageIndex: 1,
          pageSize: 5
        })
      }).then((response) => {
        if (response.ResponseData.CourseList.length >= 5) {
          this.abroadData = response.ResponseData.CourseList
        } else {
          this.abroadData = []
        }
      })
    },
    getApplyData (cid) {
      jsonp('http://deploy.xdf.cn/channel/middleschool/getChuguobikao', {
        cid
      }).then((response) => {
        this.applyData = []
        for (let i in response) {
          if (response[i].length >= 5) {
            this.applyData.push({
              title: i,
              content: response[i]
            })
          }
        }
      })
    },
    getBoutiqueClassData (cid) {
      jsonp('http://deploy.xdf.cn/channel/middleschool/getECclass', {
        cid
      }).then((response) => {
        let cnt = 0
        this.floorJunior = []
        this.floorSenior = []
        for (let i in response) {
          if (cnt < 3) {
            if (response[i].length >= 5) {
              this.floorJunior.push({
                title: i,
                content: response[i]
              })
            }
          } else {
            if (response[i].length >= 5) {
              this.floorSenior.push({
                title: i,
                content: response[i]
              })
            }
          }
          cnt += 1
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.mainswiper
  width: 1200px
  height: 524px
  margin: 0 auto
  overflow: hidden
  display: flex
  .mid-part
    float: left
    display: flex
    flex: 1
    flex-direction: column
    .content
      overflow: hidden
      .admodel
        margin: 0 8px
        float: left
      .right-part
        display: flex
        width: 251px
        height: 472px
        flex-direction: column
.specialClass
  width: 1200px
  margin: 18px auto
  overflow: hidden
.abroad
  width: 1200px
  margin: 18px auto
  overflow: hidden
  display: flex
  .content
    display: flex
    flex-direction: column
    flex: 1
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/Middlecourse.vue